import { events } from '../helper/events';
import { SidebarTrigger } from './sidebar_trigger';

class Sidebar {
  constructor(sidebarElement, animationDuration = 500) {
    this.sidebarElement = sidebarElement;
    this.animationDuration = animationDuration;
    this.closeElements = sidebarElement.querySelectorAll('[data-dismiss="sidebar"]');
    this.showBackdrop = !sidebarElement.matches('[data-cs-no-backdrop]');
    this.isShown = false;
    this.isAnimating = false;

    if (this.showBackdrop) {
      this.maskElement = document.createElement('div');
      this.maskElement.classList.add('sidebar-backdrop');
    }
  }

  open() {
    const sidebar = this;
    if (sidebar.isShown || sidebar.isAnimating) { return; }

    requestAnimationFrame(() => {
      sidebar.sidebarElement.classList.add('in');
      sidebar.isAnimating = true;

      if (sidebar.showBackdrop && !document.querySelector('.sidebar-backdrop')) {
        document.body.appendChild(sidebar.maskElement);
      }

      requestAnimationFrame(() => {
        sidebar.sidebarElement.classList.add('animate');

        if (sidebar.showBackdrop) {
          sidebar.maskElement.classList.add('in');
        }
      });

      setTimeout(() => {
        sidebar.isAnimating = false;
        sidebar.isShown = true;
      }, sidebar.animationDuration);
    });
  }

  close() {
    const sidebar = this;
    if (!sidebar.isShown || sidebar.isAnimating) { return; }

    sidebar.sidebarElement.classList.remove('animate');
    sidebar.isAnimating = true;

    if (sidebar.showBackdrop) {
      sidebar.maskElement.classList.remove('in');
    }

    setTimeout(() => {
      sidebar.sidebarElement.classList.remove('in');
      sidebar.isAnimating = false;
      sidebar.isShown = false;

      if (sidebar.showBackdrop && document.body.contains(sidebar.maskElement)) {
        document.body.removeChild(sidebar.maskElement);
      }
    }, sidebar.animationDuration);
  }

  init() {
    const sidebar = this;

    sidebar.sidebarElement.addEventListener(events.openSidebar, () => {
      sidebar.open.call(sidebar);
    });

    sidebar.sidebarElement.addEventListener(events.closeSidebar, () => {
      sidebar.close.call(sidebar);
    });

    sidebar.sidebarElement.addEventListener('mousedown', (event) => {
      if (event.target !== event.currentTarget) { return; }
      event.preventDefault();
      sidebar.close();
    });

    sidebar.closeElements.forEach((closeElement) => {
      closeElement.addEventListener('click', (event) => {
        event.preventDefault();
        sidebar.close();
      });
    });
  }
}

function initSidebars(animationDuration) {
  const triggerElements = document.querySelectorAll('[data-cs-toggle="sidebar"]');
  const sidebarElements = [...triggerElements]
    .map((triggerElement) => triggerElement.dataset.csTarget)
    .map((selector) => document.querySelector(selector))
    .filter((sidebarElement) => !!sidebarElement);

  triggerElements.forEach((triggerElement) => {
    new SidebarTrigger(triggerElement).init();
  });

  sidebarElements.forEach((sidebarElement) => {
    new Sidebar(sidebarElement, animationDuration).init();
  });
}

export { Sidebar, initSidebars };
